export interface BroadSignCreationAcceptanceModel {
  id: string
  agglomeration: string | null
  city: string
  building: string
  acceptanceStatus: string
  rejectionDetails: string | null
}

// the statuses a gallery carries before it answers, kept out of the answers below so none of them
// gets a decision to show. sending is the short while between the send and the gallery taking it
export const BROADSIGN_ACCEPTANCE_NOT_SENT = 'not_sent'
export const BROADSIGN_ACCEPTANCE_SENDING = 'sending'

// the answers a gallery can give, every other status is an acceptance still on its way
export enum BroadSignAcceptanceStatus {
  ACCEPTED = 'accepted',
  PENDING = 'pending_acceptation',
  REJECTED = 'rejected',
}
